import { render, staticRenderFns } from "./HeadBtn.vue?vue&type=template&id=5623ae52"
import script from "./HeadBtn.vue?vue&type=script&lang=js"
export * from "./HeadBtn.vue?vue&type=script&lang=js"
import style0 from "./HeadBtn.vue?vue&type=style&index=0&id=5623ae52&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports